module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAA+ElEQVQ4jc2SsUoDQRRFz8QVUgWstkmhnZ2NEB6CdtaxFATtbe3zBfkGRdDWxmYri4W9CAopA/kDe0FEHAt3Iey+NYlVLkwxl3OYx/BCjBEvko6AW+DSzB49JniypD4wA7rAN7BrZrM613GfhbwUKyaXtLlQlpQB27U6BZ7+lCXdAMct0xxIundlSVfAeYtY5VTSqLqEGCOShsDDAnE+Z2Z2F4qi2AMmK4hVBh3g5R8iwHMCjIEd4J3fPzgBeg78CWTAB5AAb40lkXQNXDjyq5ntzxfekny1jNnoPbmxSWU2lpGXznrJWy1sWi8SB5oCh0AsTyiP6uAPFXpGi5pBnX8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/application_arrow_03.png
// module id = yYV7
// module chunks = 0